import { render, staticRenderFns } from "./MembersCoordinators.vue?vue&type=template&id=b78c58c8&"
import script from "./MembersCoordinators.vue?vue&type=script&lang=js&"
export * from "./MembersCoordinators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports